import { useSelector } from 'react-redux'
import { isAdmin, isAuthenticated, hasInvalidSession } from '../session'
import { IStoreState } from '../store'

export const useAuthStatus = () => {
  try {
    const admin = useSelector<IStoreState, boolean>((state) => {
      try {
        if (!state || !state.session) {
          console.error(
            'useAuthStatus: Missing state or session in isAdmin check'
          )
          return false
        }
        return isAdmin(state.session)
      } catch (error) {
        console.error('useAuthStatus: Error in admin check:', error)
        return false
      }
    })

    const authenticated = useSelector<IStoreState, boolean>((state) => {
      try {
        if (!state || !state.session) {
          console.error(
            'useAuthStatus: Missing state or session in isAuthenticated check'
          )
          return false
        }
        return isAuthenticated(state.session)
      } catch (error) {
        console.error('useAuthStatus: Error in authenticated check:', error)
        return false
      }
    })

    const invalidSession = useSelector<IStoreState, boolean>((state) => {
      try {
        if (!state || !state.session) {
          console.error(
            'useAuthStatus: Missing state or session in hasInvalidSession check'
          )
          return false
        }
        return hasInvalidSession(state.session)
      } catch (error) {
        console.error('useAuthStatus: Error in invalidSession check:', error)
        return true // Safer to assume session is invalid if there's an error
      }
    })

    return { admin, authenticated, invalidSession }
  } catch (error) {
    console.error('useAuthStatus: Unexpected error:', error)
    // Return safe defaults
    return { admin: false, authenticated: false, invalidSession: true }
  }
}
